import React from "react";
import { Button } from "react-bootstrap";
import useAuth from "../../contexts/useAuth";
import { Constants } from "../../libs/Constants";
import NonAcceptHome from "../NonAcceptHome";

const SignUpWithTaabl = ({ user }) => {
  const { activeCompany } = useAuth();
  const [acceptTerms, setAcceptTerms] = React.useState(false);

  const renderAcceptTerms = () => {
    if (
      this.state.contributions &&
      Object.keys(this.state.contributions.length) > 0
    ) {
      return (
        <NonAcceptHome
          {...this.props}
          {...{ offerStartdate: this.state.contributions?.offerStartdate }}
          close={(e) => this.setState({ renderAcceptTerms: false })}
        ></NonAcceptHome>
      );
    } else {
      return (
        <NonAcceptHome
          {...this.props}
          close={(e) => this.setState({ renderAcceptTerms: false })}
        ></NonAcceptHome>
      );
    }
  };
  if (!user) {
    return <></>;
  }
  // we want to show sign up with taabl on when logged in user is not self signup
  if (!(user.zoneinfo !== "self" && !user.allowTaabl)) {
    return <></>;
  }
  return (
    <div className="d-flex align-content-center align-items-center mb-4">
      <Button className="px-4 py-2" onClick={(e) => setAcceptTerms(true)}>
        Sign up with Taabl
      </Button>
      <a
        href={
          activeCompany.FAQ ? activeCompany.FAQ : Constants.Default_FAQ_Link
        }
        className="secondary ms-2"
        target="_blank"
        rel="noopener noreferrer"
      >
        Have Questions?
      </a>
      {acceptTerms && renderAcceptTerms()}
    </div>
  );
};

export default SignUpWithTaabl;
